import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {  ProfileDataService } from '../../Services/index';

//import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';

//import { ControlGroup} from '@angular/common';
import { Role } from '../../Models/roles';
import { User } from '../../Models/user';
import { Page } from '../../Models/pages';


import {CheckboxModule, DataTableModule, ButtonModule, DialogModule, InputTextModule,Message, MessagesModule, CalendarModule, SelectItem, ConfirmationService} from 'primeng/primeng';

@Component({
    //moduleId: module.id,
    templateUrl: './UserCreation.html'
})

export class UserCreationComponent implements OnInit, OnDestroy {

    IsSave: boolean;
    Error: boolean;
    zone: any;
    checked: boolean = false;
    page: PrimePage = new PrimePage();
    role: PrimeRole = new PrimeRole();
    dropdownlist: SelectItem[];
    displayDialog: boolean;
    Label: string;
    user: PrimeUser = new PrimeUser();
    isEmailTake: boolean;
    selectedTeamMemberProfile: User;

    newUser: boolean;
    pages: Page[];
    users: PrimeUser[];
    roles: PrimeRole[];
    msgs: Message[] = [];
    userform: PrimeUser;

    submitted: boolean;
    ValidEmailID: boolean;
    PageIsvalid: boolean;
    selectedLOV: string = "0";
    IsDelete: boolean;
   

    selectedCategories: string[] = ['Technology', 'Sports'];

    constructor(private route: ActivatedRoute,
        private router: Router,private profiledataservice: ProfileDataService, private fb: FormBuilder, private confirmationService: ConfirmationService) {

        if (JSON.parse(window.localStorage.getItem('pagedetails')) != null) {
            this.pages = JSON.parse(window.localStorage.getItem('pagedetails'));
            if (router.url != '/home') {
                var isValid = false;
                for (var i = 0; i < this.pages.length; i++) {
                   
                    if (this.pages[i].url == router.url) {
                      
                        
                        if (this.pages[i].permissionID == 1) {
                           
                            this.IsDelete = false;
                            this.IsSave = false;
                        }
                        if (this.pages[i].permissionID == 2) {
                            this.IsDelete = false;
                            this.IsSave = true;
                        }
                        if (this.pages[i].permissionID == 3) {

                            this.IsDelete = true;
                            this.IsSave = true;
                        }
                        
                    }
                    

                }
            }

        }
    }

	ngOnDestroy() { }
    ngOnInit() {
        this.PageIsvalid = true;
        this.ValidEmailID = true;
        this.isEmailTake = true;
        this.userform = this.fb.group({
            'email': ["", Validators.required],
            'role': ["", Validators.required]
            
        });
        this.ValidEmailID = true;

        this.initialize();

    }

    initialize(){
        setTimeout(() => {
            this.profiledataservice.GetUsers().subscribe((lstprofiles: User[]) => {

                this.users = lstprofiles;
                this.profiledataservice.GetRoleNameList().subscribe((role: Role[]) => {
                    let _data = this.TeamMemberListBind(JSON.stringify(role), "Select Role");

                    this.dropdownlist = _data;
                });
                                
            }
            );
        }, 800);
       
    }

	updateChecked(page: any, event: any) {

        this.checked = false;
        if (event.target.checked) {
            page.assigned = event.target.checked;
            page.userid = this.user.id;
            page.roleID = this.user.roleID;
        } else {
            page.assigned = false;
        }
        for (var i = 0; i < this.pages.length; i++) {
            if (this.pages[i].assigned) {
                this.checked = true;
            }

        }


    }
	ValidEmail(user: any) {
        var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        if (!EMAIL_REGEXP.test(this.user.email.toString())) {
            this.ValidEmailID = false;
            this.PageIsvalid = false;

        } else {
            this.ValidEmailID = true;
            this.PageIsvalid = true;
        }
        if (!this.user.email.toString().includes("infobeans.com")) {
            this.ValidEmailID = false;
            this.PageIsvalid = false;

        } else {
            this.ValidEmailID = true;
            this.PageIsvalid = true;
        }
        this.isEmailTake = true;
        var userList = this.users;

        var email = user.email;
        var id = user.id;
        if (userList != null && userList.length > 0) {
            var filteredUserList = userList.filter(function (userItem) {
                return userItem.email == email && userItem.id != id;
            });
            if (filteredUserList != null && filteredUserList.length > 0) {
                this.isEmailTake = false;
                this.PageIsvalid = false;
                //return false;
            }
            else {
                this.isEmailTake = true;
                this.PageIsvalid = true;

            }
            console.log('filteredUserList: ', filteredUserList);
        }
    }
	onRowSelect(event: any, data: any) {
        this.user = data;
        this.ShowAddEditDialog(false);
    }
  
    ShowAddEditDialog(isNew:boolean) {
        //this.userform.markAsPristine();
        this.Error = false;
        this.ValidEmailID = true;
        this.isEmailTake = true;
       
        this.Label = "Edit User";
        if (isNew)  {
            this.Label = "Add User";
            this.newUser = true;
            this.user = new PrimeUser();
        }
        
       
        else {
            //this.user = new PrimeUser();
        }
        this.displayDialog = true;
    }
	TeamMemberListBind(data: any, _firstOption: any) {
        var obj = JSON.parse(data);

        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            objddl.push({ 'label': _firstOption, 'value': '' })

            for (var i = 0; i < obj.length; i++) {

                if (obj[i].hasOwnProperty("name")) {                    
                    objddl.push({ 'label': obj[i]["name"], 'value': obj[i]["id"] });
                }
            }
        }
        return objddl;
    }


    save() {

        if (this.newUser)
            this.users.push(this.user);
        else
            this.users[this.findSelectedLeaveTypeIndex()] = this.user;

        this.user = null;
        this.displayDialog = false;
    }
    cancel() {
        this.displayDialog = false;
    }
	delete(event: any, data: any) {
        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this record?',
            accept: () => {
        this.user = this.cloneLeaveType(data);
        this.user.active = false;
        this.profiledataservice.AddUser(this.user).subscribe((data) => {

            //this.ngOnInit();
            this.initialize();
            // this.bindList(this.selectedTeamMemberProfile);
            this.msgs.push({ severity: 'info', summary: 'Success', detail: 'User deleted successfully !' });
        });
            }
        });


       
    }

    

    cloneLeaveType(c: User): PrimeUser {
        let editrole = new PrimeUser();
        for (let prop in c) {
            editrole[prop] = c[prop];
        }
        return editrole;
    }

    findSelectedLeaveTypeIndex(): number {

        return this.users.indexOf(this.selectedTeamMemberProfile);
    }


    onSubmit(value: string) {
        if (this.PageIsvalid) {
            this.checked = true;
            if (this.checked) {
                if (this.newUser) {
                    this.profiledataservice.AddUser(this.user).subscribe((data) => {

                        //this.ngOnInit();
                        this.initialize();
                        this.msgs.push({ severity: 'info', summary: 'Success', detail: 'User save successfully !' });
                    });
                   // this.profiledataservice.AddUser(this.user);


                    this.users.push(this.user);


                }
                else {

                    this.profiledataservice.AddUser(this.user).subscribe((data) => {

                        //this.ngOnInit();
                        this.initialize();
                        this.msgs.push({ severity: 'info', summary: 'Success', detail: 'User save successfully !' });
                    });
                    // this.profiledataservice.AddUser(this.user);

                    this.users[this.findSelectedLeaveTypeIndex()] = this.user;
                    this.users.push(this.user);
                }


                this.displayDialog = false;


                this.submitted = true;
                this.msgs = [];
                this.IsSave = true;

                // this.user = null;
            //    this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Users save successfully !' });

                //this.ngOnInit();
                this.initialize();
            } else {
                this.Error = true;
            }
        }
    }

}

class PrimeRole implements Role {
	constructor(public id?: any, public name?: any, public description?: any, public notes?: any
    ) { }
}
class PrimePage implements Page {
	constructor(public id?: any, public name?: any, public assigned?: any, public userid?: any, public roleID?: any, public url?: any, public description?: any
    ) { }
}


class PrimeUser implements User {
	constructor(public email?: any,
		public password?: any,
		public name?: any,
		public roleName?: any,
		public result?: any,
		public createdBy?: any,
		public createdDate?: any,
		public modifiedBy?: any,
		public modifiedDate?: any,
		public id?: any,
		public active?: any,
		public isDelete?: any,
		public selectedCategories?: any,
		public roleID?: any
    ) { }
}





// WEBPACK FOOTER //
// ./src/app/Components/UserManagement/UserCreation.ts